import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { registerSW } from 'virtual:pwa-register'
import App from './App'
import { AuthGate } from './components/AuthGate'
import { AppStateProvider } from './state/AppState'
import './styles.css'

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 60_000, retry: 1, refetchOnWindowFocus: false } } })
registerSW({ immediate: true })

createRoot(document.getElementById('root')!).render(<StrictMode><QueryClientProvider client={queryClient}><BrowserRouter><AppStateProvider><AuthGate><App/></AuthGate></AppStateProvider></BrowserRouter></QueryClientProvider></StrictMode>)

